import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "../../../../../utils/notifications"; 
import ConfigPhiKhacApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacApi";
import ConfigPhiKhacHangKyApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigPhiKhacHangKyApi";

export const ModalSuDung = ({ show, onHide, item, onChanged, isPeriodic }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    useEffect(() => {
        if (show) {
            setIsSubmit(false);
        }
    }, [show]);

    if (!item) return null;

    const api = isPeriodic ? ConfigPhiKhacHangKyApi : ConfigPhiKhacApi;
    const isActivating = !item.Active;
    const handleFormSubmit = async (e) => {
        e.preventDefault(); 
        setIsSubmit(true);
        try {
            const res = await api.changeStatus(item.ConfigPhiKhacId);
            if (res.status === 200) {
                pushNotification("Thay đổi trạng thái thành công!", "success", "TOP_CENTER", 2000);
                onChanged();
            } else {
                pushNotification(res.data || "Thay đổi trạng thái thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (err) {
            pushNotification(err?.response?.data || "Thay đổi trạng thái thất bại!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsSubmit(false);
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered className="modal-new modal-fade">
            <form onSubmit={handleFormSubmit}>
                <Modal.Header>
                    <h4 className="modal-title color7-bold ml-1">Xác nhận thay đổi trạng thái</h4>
                    <button type="button" className="close-popup-new" onClick={onHide}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: '16px' }}>
                        Bạn có chắc chắn muốn <strong>{isActivating ? "bật (sử dụng)" : "tắt (không sử dụng)"}</strong> phí: <strong>{item.TenPhiKhac}</strong>?
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide}>Hủy</button>
                    <button type="submit" className={`btn btn-new-main ${isActivating ? 'btn-success' : 'btn-danger'}`} disabled={isSubmit}>
                        {isSubmit ? "Đang xử lý..." : "Đồng ý"}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};